import { registerProfile } from '../../../lib/profiles';
import { TopologyProfile } from './topology.profile';
import { SecurityProfile } from './security.profile';
import { CostProfile } from './cost.profile';

export { TopologyProfile } from './topology.profile';
export { SecurityProfile } from './security.profile';
export { CostProfile } from './cost.profile';

export const NetworkProfiles = [TopologyProfile, SecurityProfile, CostProfile];

export function registerNetworkProfiles(): void {
  for (const profile of NetworkProfiles) {
    registerProfile(profile);
  }
}
